// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  .page-list {
    display: block;
  }
  .page {
    margin: 0;
  }
  @page portrait {
    size: portrait;
  }
  @page landscape {
    size: landscape;
  }
  .portrait {
    page: portrait;
  }
  .landscape {
    page: landscape;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commonStyles/print.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media print {\n  .page-list {\n    display: block;\n  }\n  .page {\n    margin: 0;\n  }\n  @page portrait {\n    size: portrait;\n  }\n  @page landscape {\n    size: landscape;\n  }\n  .portrait {\n    page: portrait;\n  }\n  .landscape {\n    page: landscape;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
